import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-add-notes-modal',
  templateUrl: './add-notes-modal.component.html',
  styleUrl: './add-notes-modal.component.scss',
})
export class AddNotesModalComponent {
  @Input() fromNewMessage: boolean = false;
  @Input() addedNote: string = '';
  noteText: string = '';
  isVisible: boolean = false;
  @Output() dataEmitter = new EventEmitter<string>();
  public openModal() {
    this.isVisible = true;
    if(this.fromNewMessage && this.addedNote.trim() !== '') {
      this.noteText = this.addedNote;
    }
  }
  public closeModal() {
    this.isVisible = false;
    this.noteText = '';
  }
  submitNotes() {
    this.dataEmitter.emit(this.noteText);
    this.closeModal();
  }
}
